import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <img src="/images/hsm-offline-banner.jpg" alt="About Us Hero" />
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>H</span>
                                    <span>S</span>
                                    <span>M</span>
                                    <span>&nbsp;</span>
                                    <span>O</span>
                                    <span>F</span>
                                    <span>F</span>
                                    <span>L</span>
                                    <span>I</span>
                                    <span>N</span>
                                    <span>E</span>
                                </div>
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 